import React, { useEffect, useState } from 'react';
import styles from './BlogBuilder.module.scss';
import images from '../../../core/constants/images';
import ScreenHeader from '../../components/ScreenHeader/ScreenHeader';
import Footer from '../../components/Footer/Footer';
import BlogCard from '../../components/BlogCard';
import MainButton from '../../components/MainButton';
import { colors } from '../../../core/theme/colors';
import ScrollUp from '../../components/ScrollUp/ScrollUp';
import { getBlogPosts } from '../../../functions/firebase';
import { Link } from 'react-router-dom';

interface BlogType {
  title: string;
  date: string;
  image: any;
  category: string;
  all: string;
  color: string;
  background: any;
  text: string;
}

interface FirebaseBlogType {
  blogTitle: string;
  blogDate: string;
  blogCategory: string;
  blogBody: string;
  all: string;
  color: string;
  image: any;
  background: any;
  authorName: string;
  authorFunction: string;
  authorImage: string;
}

const BlogBuilder = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('All');
  const [loadMore, setLoadMore] = useState<number>(6);
  const [filteredBlogs, setFilteredBlogs] = useState<FirebaseBlogType[]>([]);
  const [blogsArray, setBlogsArray] = useState<FirebaseBlogType[]>([]);

  const getAndFactorBlogArray = async () => {
    let blogPosts: FirebaseBlogType[] = await getBlogPosts();
    const formattedBlogArray = blogPosts.map(blog => {
      return {
        ...blog,
        all: 'All',
        color:
          blog.blogCategory === 'Development'
            ? colors.orange
            : blog.blogCategory === 'Marketing'
            ? colors.secondary
            : colors.pink,
        image: blog.image,
      };
    });
    setBlogsArray(formattedBlogArray);
  };

  useEffect(() => {
    const filteredArray = blogsArray.filter(
      categ =>
        categ.blogCategory
          .toLowerCase()
          .match(selectedCategory.toLowerCase()) ||
        categ.all?.match(selectedCategory)
    );
    setFilteredBlogs(filteredArray);
  }, [selectedCategory, blogsArray]);

  useEffect(() => {
    getAndFactorBlogArray();
  }, []);

  return (
    <div className={styles.container}>
      <Link to={'/blogBuilder/newBlogPost'} className={styles.addNewPostButton}>
        <MainButton title={'ADD NEW POST'} primaryColor={colors.cyan} />
      </Link>

      <div className={styles.blogContainer}>
        {filteredBlogs.length > 0 ? (
          filteredBlogs
            .slice(0, loadMore)
            .map((item, index) => (
              <BlogCard
                image={item.image}
                date={item.blogDate}
                title={item.blogTitle}
                color={item.color}
                category={item.blogCategory}
                key={index}
                item={item}
                edit={true}
                customStyle={styles}
              />
            ))
        ) : (
          <img
            src={images.blogSoon}
            className={styles.blogSoonImage}
            alt="icon"
          />
        )}
      </div>
      <div>
        {loadMore < filteredBlogs.length ? (
          <MainButton
            title={'LOAD MORE'}
            primaryColor={colors.cyan}
            onClick={() => setLoadMore(loadMore + 6)}
          />
        ) : null}
      </div>
      <ScrollUp />
      <Footer />
    </div>
  );
};

export default BlogBuilder;
